import { render, staticRenderFns } from "./equipment-item.vue?vue&type=template&id=4e98a4a8&"
import script from "./equipment-item.vue?vue&type=script&lang=js&"
export * from "./equipment-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports